import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'


const PROPERTY_NAME_KEY = "property_names";
const PROPERTY_NAME_TIMESTAMP_KEY = "property_names_timestamp";
const TWO_HOURS = 2 * 60 * 60 * 1000;

const ProspectPropertyService = {
    
    getProspectProperties: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/list`, body);
    },
    createProspectProperty: async (propertyData) => {
     return axios.post(`${baseUrl}/prospect-properties/create`, propertyData)
    },
    updateProspectProperty: async (propertyId, propertyData) => {
        return axios.put(`${baseUrl}/prospect-properties/${propertyId}`, propertyData)
    },
    getProspectPropertyId: async (propertyId) => {
        return axios.get(`${baseUrl}/prospect-properties/${propertyId}`);
    },
    getProspectPropertyGeoData: async () => {
        return axios.get(`${baseUrl}/prospect-properties/geo-points`);
    },
    postPropertyAttachments: async ( formData) => {
        return axios.post(`${baseUrl}/prospect-properties/attach-documents`, formData)
    },
    postPropertyAdvocateAssignment: async ( body) => {
        return axios.post(`${baseUrl}/prospect-properties/assign-advocate`, body)
    },
    getPropertyNameList: async () => {
        const now = Date.now();
    
        const cachedData = localStorage.getItem(PROPERTY_NAME_KEY);
        const cachedTimestamp = localStorage.getItem(PROPERTY_NAME_TIMESTAMP_KEY);
    
        if (cachedData && cachedTimestamp && now - cachedTimestamp < TWO_HOURS) {
          return JSON.parse(cachedData);
        }
    
       
        const response = await axios.get(`${baseUrl}/prospect-properties/names`);
    
        localStorage.setItem(PROPERTY_NAME_KEY, JSON.stringify(response.data));
        localStorage.setItem(PROPERTY_NAME_TIMESTAMP_KEY, now);
    
        return response.data;
      },


    // Property Query
    getPropertyQueries: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/queries`, body);
    },
    getPropertyQueryById: async (queryId) => {
        return axios.get(`${baseUrl}/propspect-properties/query/${queryId}`);
    },
    createPropertyQuery: async ( queryData) => {
        return axios.post(`${baseUrl}/propspect-properties/query`, queryData)
    },
    updatePropertyQuery: async ( queryData) => {
        return axios.post(`${baseUrl}/prospect-properties/query/update`, queryData)
    },
    updatePropertyQueryStatus: async ( statusData) => {
        return axios.put(`${baseUrl}/prospect-properties/query/status`, statusData)
    },
    addQueryResponse: async ( responseData) => {
        return axios.post(`${baseUrl}/prospect-properties/query/add-response`, responseData)
    },
    getOverAllQueryPropertyList : async (body) => {
        return axios.get(`${baseUrl}/prospect-properties/query/status-counts`, body);
    },
    getQueryHistoryById : async (queryId) => {
        return axios.get(`${baseUrl}/prospect-properties/query/${queryId}/history`);
    },


    // Frontend users list
     getFrontendUsersList: async () => {
        return axios.get(`${baseUrl}/prospect-properties/frontend-users-with-assignments`);
     },
     updateFrontendUserAssignment: async ( assignmentData) => {
        return axios.post(`${baseUrl}/prospect-properties/assign-frontend-user`, assignmentData)
     },


     // Legal Analysis APIs can be added here

     getOverallLegalSummary: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/queries/category/overall-counts`, body);
     },
     getAdvocateWiseLegalSummary: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/queries/category/Advocate%20Analysis`, body);
     },
     getAVOLegalSummary: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/queries/category/VOA%20Analysis`, body);
     },
     getPhysicalInspectionLegalSummary: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/queries/category/Physical%20Inspection`, body);
     },
     getRegisterOfficeLegalSummary: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/queries/category/Register%20Office%20Analysis`, body);
     },
     getOtherLegalSummary: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/queries/category/Other%20Analysis`, body);
     },


     // Unit Management APIs can be added here

     createUnits: async ( unitData) => {
        return axios.post(`${baseUrl}/prospect-properties/create-units`, unitData)
     },
     getUnitsByPropertyId: async (body) => {
        return axios.post(`${baseUrl}/prospect-properties/get-units`, body);
     },
     updateUnitById: async (unitData) => {
        return axios.put(`${baseUrl}/prospect-properties/update/units`, unitData)
     },
     deleteUnitById: async (propertyId, unitId) => {
        return axios.delete(`${baseUrl}/prospect-properties/${propertyId}/units/${unitId}`);
     },


     // Stage Management APIs can be added here

moveToNextStage: async (body) => {
        return axios.put(`${baseUrl}/prospect-proerties/move-to-next-stage`, body)
},
getStatusDetails: async (propertyId) => {
    return axios.get(`${baseUrl}/prospect-properties/${propertyId}/status-details`);
},

// Dashboad Count 

getDashboardCounts: async (body) => {
    return axios.post(`${baseUrl}/prospect-properties/dashboard-counts`, body);

},

/// Stage wise get data

getStageWiseProperties: async (body) => {
    return axios.post(`${baseUrl}/prospect-properties/stageWiseDataAgainstProperty`, body);
},

// Get Analysis User data 
getAnalysisUsersList: async (propertyId) => {
    return axios.get(`${baseUrl}/prospect-properties/${propertyId}/analysis-wise-users`);
},


analysisUpdateOpinions: async (body) => {
    return axios.post(`${baseUrl}/prospect-properties/advocate-analysis/update`, body);
},
analysisUpdateResponseAdd : async (body) => {
    return axios.post(`${baseUrl}/prospect-properties/advocate-analysis/response-update`, body);   
},
analysisDocumentMarkUpdate : async (body) => {
    return axios.post(`${baseUrl}/prospect-properties/analysisUpdateAgainstProperty/stages`, body);
},

// Prospect Property document upload list

getPropertyDocumentList: async (body) => {
    return axios.post(`${baseUrl}/prospect-properties/get-all-attachments`, body);
}

    
}

export default ProspectPropertyService
